import React, { createContext, useContext, useEffect, useState } from 'react'
import * as microsoftTeams from '@microsoft/teams-js'

interface TeamsContextValue {
  isInTeams: boolean
  isInitialized: boolean
}

const TeamsContext = createContext<TeamsContextValue>({
  isInTeams: false,
  isInitialized: false,
})

export function TeamsProvider({ children }: { children: React.ReactNode }) {
  const [isInTeams, setIsInTeams] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const initialize = async () => {
      try {
        await microsoftTeams.app.initialize()
        setIsInTeams(true)
      } catch {
        // Not running inside Teams — normal browser
        setIsInTeams(false)
      } finally {
        setIsInitialized(true)
      }
    }
    initialize()
  }, [])

  return (
    <TeamsContext.Provider value={{ isInTeams, isInitialized }}>
      {children}
    </TeamsContext.Provider>
  )
}

export function useTeams() {
  return useContext(TeamsContext)
}
